// Tourist-facing plan navigation — linear, plain language, no coverage % or hub loops.

export const TOURIST_PLAN_GROUPS = [
		{
		id: 'before',
		title: 'Before you fly',
		steps: [
			{ id: 'book-domestic-air', label: 'Flights', route: '/flights', highlight: true },
			{ id: 'visa', label: 'Visa', route: '/visa' },
			{ id: 'flights-guide', label: 'Intl. flights guide', route: '/plan/flights' },
			{ id: 'insurance', label: 'Insurance', route: '/plan/insurance' },
			{ id: 'packing', label: 'Packing', route: '/plan/packing' },
			{ id: 'season', label: 'When to visit', route: '/seasonal-discovery' },
			{ id: 'festivals', label: 'Festivals', route: '/festivals', highlight: true },
		],
	},
	{
		id: 'arrival',
		title: 'When you land',
		steps: [
			{ id: 'arrival', label: 'Airport arrival', route: '/arrival' },
			{ id: 'sim', label: 'SIM & internet', route: '/plan/sim' },
			{ id: 'transport', label: 'Getting around', route: '/transportation' },
		],
	},
	{
		id: 'during',
		title: 'During your trip',
		steps: [
			{ id: 'safety', label: 'Safety', route: '/safety' },
		],
	},
	{
		id: 'discover',
		title: 'Discover Nepal',
		steps: [
			{ id: 'trekking', label: 'Trekking', route: '/trekking' },
			{ id: 'temples', label: 'Temples', route: '/temples' },
			{ id: 'food', label: 'Food', route: '/plan/food' },
		],
	},
];

export const TOURIST_PLAN_STEPS = TOURIST_PLAN_GROUPS.flatMap((g) => g.steps);

/** Domestic flights + visa are linked elsewhere (nav, home band). */
export const HIDDEN_PLAN_RAIL_STEP_IDS = new Set(['book-domestic-air', 'visa']);

export function planStepsForRail(steps) {
	return (steps || []).filter((s) => !HIDDEN_PLAN_RAIL_STEP_IDS.has(s.id));
}

const PLAN_ROUTE_EXACT = new Set(TOURIST_PLAN_STEPS.map((s) => s.route));
PLAN_ROUTE_EXACT.add('/government');

/** Booking hubs use their own layout — not the plan guide chrome. */
export const BOOKING_HUB_ROUTES = new Set([
	'/flights',
	'/book-experiences',
	'/group-trips',
	'/packages',
	'/shared-rentals',
	'/book-everest-base-camp-trek',
]);

export function isPlanGuideRoute(pathname) {
	if (BOOKING_HUB_ROUTES.has(pathname)) return false;
	if (PLAN_ROUTE_EXACT.has(pathname)) return true;
	if (pathname.startsWith('/plan/')) return true;
	if (pathname.startsWith('/festivals')) return true;
	return false;
}

export function planGroupForStepId(stepId) {
	if (!stepId) return null;
	return TOURIST_PLAN_GROUPS.find((g) => g.steps.some((s) => s.id === stepId)) || null;
}

export function planStepByRoute(pathname) {
	const exact = TOURIST_PLAN_STEPS.find((s) => pathname === s.route);
	if (exact) return exact;
	if (pathname.startsWith('/festivals')) {
		return TOURIST_PLAN_STEPS.find((s) => s.id === 'festivals') || null;
	}
	if (pathname === '/government') return TOURIST_PLAN_STEPS.find((s) => s.id === 'visa');
	if (pathname.startsWith('/plan/')) {
		const slug = pathname.replace('/plan/', '').split('/')[0];
		return TOURIST_PLAN_STEPS.find((s) => s.route === `/plan/${slug}`) || null;
	}
	return null;
}

export function planNextStep(currentId) {
	const idx = TOURIST_PLAN_STEPS.findIndex((s) => s.id === currentId);
	if (idx < 0 || idx >= TOURIST_PLAN_STEPS.length - 1) return null;
	return TOURIST_PLAN_STEPS[idx + 1];
}

export function planPrevStep(currentId) {
	const idx = TOURIST_PLAN_STEPS.findIndex((s) => s.id === currentId);
	if (idx <= 0) return null;
	return TOURIST_PLAN_STEPS[idx - 1];
}

export const TOURIST_SECTIONS = {
	home: { label: 'Home', route: '/' },
	places: { label: 'Places', route: '/#places' },
	plan: { label: 'Plan', route: '/#plan' },
	journey: { label: 'Journey', route: '/#journey' },
};

export const LIFECYCLE_TOURIST_REDIRECTS = {
	dream: '/#plan',
	research: '/#places',
	'choose-destination': '/#places',
	sightseeing: '/#places',
	shopping: '/#places',
	adventure: '/#journey',
	departure: '/#plan',
	souvenirs: '/#plan',
	'return-home': '/#plan',
	atm: '/arrival',
	hotel: '/#places',
};

export const LIFECYCLE_SLUG_TO_PLAN_STEP = {
	flights: 'flights',
	insurance: 'insurance',
	packing: 'packing',
	sim: 'sim',
	food: 'food',
};

export function planStepIdFromLifecycleSlug(slug) {
	return LIFECYCLE_SLUG_TO_PLAN_STEP[slug] || null;
}
